import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";
import { CreateProductTitleBar } from "../../../../configs/products";

interface TitleProps {
  title: string;
  setValidated: (validated: boolean) => void;
  submitForm: Function;
  isLoading?: boolean;
}

const Title = ({ title, setValidated, submitForm, isLoading }: TitleProps) => {
  const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
  const navigate = useNavigate();

  const titleActions: TitleAction[] = [
    {
      title: CreateProductTitleBar.cancelButton,
      variant: "outlined",
      onClick: () => setIsOpenCancelModal(true),
    },
    {
      title: CreateProductTitleBar.addButton,
      variant: "contained",
      onClick: () => {
        setValidated(true);
        submitForm();
      },
      isLoading: isLoading
    },
  ];

  return (
    <>
      <TitleRow title={title} actions={titleActions} />
      {isOpenCancelModal && (
        <CancelModal
          open={isOpenCancelModal}
          title={WarningProductModal.title}
          contentText={WarningProductModal.context}
          handleConfirm={() => navigate("/products/")}
          handleClose={() => setIsOpenCancelModal(false)}
        />
      )}
    </>
  );
};

export default Title;
